import poster1 from "../../Images/posters/poster-1.jpg";
import poster2 from "../../Images/posters/poster-2.jpg";
import poster3 from "../../Images/posters/poster-3.jpg";
import poster4 from "../../Images/posters/poster-4.jpg";
import poster5 from "../../Images/posters/poster-5.jpg";
import poster6 from "../../Images/posters/poster-6.jpg";
import poster7 from "../../Images/posters/poster-7.png";
import poster8 from "../../Images/posters/poster-8.png";
import poster9 from "../../Images/posters/poster-9.jpg";
import poster10 from "../../Images/posters/poster-10.jpg";

export const data = [
  {
    id: 1,
    img: poster1,
  },
  {
    id: 2,
    img: poster2,
  },
  {
    id: 3,
    img: poster3,
  },
  {
    id: 4,
    img: poster4,
  },
  {
    id: 5,
    img: poster5,
  },
  {
    id: 6,
    img: poster6,
  },
  {
    id: 7,
    img: poster7,
  },
  {
    id: 8,
    img: poster8,
  },
  {
    id: 9,
    img: poster9,
  },
  {
    id: 10,
    img: poster10,
  },
];
